<presto-player [targetId]="targetId()" [token]="token()" [googleCastId]="googleCastId()"
    [castDebug]="castDebug()" [isAdvertisingRunning]="isAdvertisingRunning()">
    @if(present().compactControls){
    <player-compact-controls player-compact-controls></player-compact-controls>
    }@else if(present().events) {
    <player-events player-event-block></player-events>
    }
    @if(present().header){
    <player-header player-header></player-header>
    }
    @if(present().message){
    <player-message player-message></player-message>
    }
    @if(present().similarContent){
    <player-similar-content player-similar-content
        [similarContent]="similarContentItems()"></player-similar-content>
    }
    @if(present().skipIntro){
    <!-- The prebuilt player lib has no dedicated slot; the binge slot is the always-visible bottom-right overlay. -->
    <player-skip-intro player-binge></player-skip-intro>
    }
    @if(present().binge){
    <player-binge player-binge [nextItem]="nextItem()"></player-binge>
    }
    @if(present().controls){
    <player-controls player-controls></player-controls>
    }

</presto-player>